module.exports = ":host {\n  display:block;\n  color:white;\n  background:white;\n  padding:3rem;\n  border-radius:3px;\n}\n\n.editor {\n  background:white;\n  font-size:3rem;\n  min-height: 200px; width:100%; overflow: auto\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/code-example/code-example.component.css
// module id = ./src/app/code-example/code-example.component.css
// module chunks = main